/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from "react";
import "./Profilepop.css";
import common from "../config/common.json";
import Accountpopup from "./Accountpopup";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";
import General from "./Genrel";
import ChangePassword from "../ChangePassword";
import {useIntl} from 'react-intl';

import getGlobalVarContext from "../context/getGlobalVarContext";
function UpgradePlan({ onClick }) {
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [userDetalis, SetUserDetalis] = useState([]);
  const [openAccountPopUp, setOpenAccountPopUp] = useState(false);
  const [openUpgradePlan, setOpenUpgradePlan] = useState(false);
  const { globalVar, setGlobalVar } = useContext(getGlobalVarContext());
  const [coupendata, setcoupendata] = useState("");
  const [changePoppup, setChangePoppup] = useState(false);
  const [generalPage, SetgeneralPage] = useState(true);
  const [expiryDate, SetExpiryDate] = useState("");
  const [checkSubscriptionData, setcheckSubscriptionData] = useState(true);
  const [withoutSubscription, setWithoutSubscription] = useState(true);
  const [apiError, setApiError] = useState("");
  const [upgradePlan, setUpgradePlan] = useState([]);
  const [plan, setPlan] = useState("");
  const { email, page } = globalVar;
  const intl = useIntl()
  var requestOptions = {
    method: "GET",
  };

  const checkResponse = async () => {
    fetch(
      `${common.BASEURL}/user/details?email=${
        email !== null ? email : localStorage.getItem("email")
      }`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        SetExpiryDate(result.msg.plan_expiry_status);
        var list = [];
        list.push(result.msg);
        if (result.msg.subscription_id === undefined) {
          setcheckSubscriptionData(false);
        } else {
          SetUserDetalis(list);
        }
      })
      .catch((error) => {
        setcheckSubscriptionData(false);
      });
  };
  async function checkValidationForCoupen() {
    if(plan === ""){
      setApiError(intl.formatMessage({id: "selectPlanError"}))
      return
    }
    setIsLoading(true);
    if (coupendata !== "") {
      var raw = JSON.stringify({
        email: email !== null ? email : localStorage.getItem("email"),
        CouponCode: coupendata,
      });
      var requestOptions = { method: "POST", body: raw };
      var res = await fetch(`${common.BASEURL}/user/coupon`, requestOptions);
      // eslint-disable-next-line no-unused-vars
      // var response = await res.json();

      if (res.status === 200) {
        setOpenAccountPopUp(true);
        setOpenUpgradePlan(false);
        setIsLoading(false);
      }
      if (res.status === 404) {
        setApiError(intl.formatMessage({id: "couponIsNotValid"}));
        setIsLoading(false);
      }
    } else {
      setOpenAccountPopUp(true);
      setOpenUpgradePlan(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    setGlobalVar((oldData) => ({
      ...oldData,
      page: true,
    }));
    checkResponse();
    setOpenUpgradePlan(true);
    setIsLoading(true);
    fetch(`${common.BASEURL}/user/plan`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // eslint-disable-next-line no-unused-vars
        var test_plan = [];
        for (const val of result.msg) {
          if (common.plan.includes(val.plan)) {
            var plan = common.plan[common.plan.indexOf(val.plan)];
            if (plan === val.plan) {
              val["discription"] =val["description"]
              val["price"] = "$" + val["price"];
              test_plan.push(val);
            }
          }
        }

        setIsLoading(false);
        setUpgradePlan(test_plan);
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="profilePopUpMain">
        <div className="profilepop upgrade">
          <div className="profilepop_header">
            <h2
              className={show?"active":""}
              onClick={() => {
                setShow(true);
              }}
            >
              {intl.formatMessage({id: "currentPaymentLableAccount"})}
            </h2>
            {page ? (
              <h2
                className={!show?"active":""}
                onClick={() => {
                  setShow(false);
                }}
              >
              {intl.formatMessage({id: "paymentInfoPageChangePasswordLable"})}

              </h2>
            ) : (
              ""
            )}
          </div>
          {show ? (
            userDetalis[0] !== undefined &&
            userDetalis[0].subscription_id !== undefined && (Number(new Date().getTime())-Number(userDetalis[0].plan_end_date) < 0)
            ? (
              <General />
            ) : (
              <div>
                {isLoading && <LoadingSpinner />}
                {!openAccountPopUp && openUpgradePlan && !isLoading && (
                  <div className="profilepop_form upgrade_form">
                    <div className="center">{apiError}</div>
                    <h3>{intl.formatMessage({id: "UpgradePlanLable"})}</h3>
                    {upgradePlan.map((item, index) => {
                    return(
                      <div>
                      <button
                        key={index}
                        id={item.plan}
                        className="plan_show"
                        onClick={() => {
                          document.getElementById(item.plan).style.background =
                            "var(--primary-color)";
                          document.getElementById(item.plan).style.color =
                            "white";
                          if (plan !== "") {
                            document.getElementById(plan).style.background =
                              "#dfdfdf";
                            document.getElementById(plan).style.color =
                              "#2769d3";
                            if (plan === item.plan) {
                              setPlan("");
                              return;
                            }
                          }
                          setApiError("")
                          setPlan(item.plan);
                        }}
                      >
                        {item.plan} {item.price}
                      </button>
                      <div className="itemDiscription">{item.discription}</div>
                      </div>
                )})}

                    <div className="centergrid">
                      <p>{intl.formatMessage({id: "EnterCouponCode"})}</p>
                      <input
                        className="inputbuuton_coupen"
                        value={coupendata}
                        placeholder={intl.formatMessage({id: "EnterCouponCode"})}
                        autoComplete="off"
                        onChange={(e) => {
                          setcoupendata(e.target.value.toUpperCase());
                          setApiError("");
                        }}
                        name={intl.formatMessage({id: "EnterCouponCode"})}
                        type="text"
                      />

                      <button
                        className="profilepop_button Your_Current_plan_button"
                        onClick={() => {
                          checkValidationForCoupen();
                        }}
                      >
                        {intl.formatMessage({id: "NextButtonInCoupon"})}
                      </button>
                    </div>
                  </div>
                )}
                {openAccountPopUp && !openUpgradePlan && !isLoading && (
                  <Accountpopup plan={plan} coupendata={coupendata} />
                )}
              </div>
            )
          ) : (
            <ChangePassword />
          )}
        </div>
      </div>
    </>
  );
}
export default UpgradePlan;
